import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Resolve a stored media path: external URLs pass through; internal "/therapists/photo/..."
// paths (relative to /api) get the backend origin prefixed.
export const mediaUrl = (p) => {
  if (!p) return "";
  if (/^https?:\/\//i.test(p)) return p;
  return `${API_BASE}${p.startsWith("/") ? p : "/" + p}`;
};

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function track(name, props = {}) {
  api.post("/analytics/event", { name, props }).catch(() => {});
}

// After sign-in/registration, persist anything captured in the pre-auth "Get Started" funnel.
export async function applyPreAuthData(user) {
  try {
    const prefsRaw = sessionStorage.getItem("sh_prefs");
    const resultRaw = sessionStorage.getItem("sh_last_result");
    let updated = user;
    if (!user?.onboarding_completed && (prefsRaw || resultRaw)) {
      const prefs = prefsRaw ? JSON.parse(prefsRaw) : {};
      const bothDone = !!prefsRaw && !!resultRaw;
      const { data } = await api.put("/profile", { ...prefs, ...(bothDone ? { onboarding_completed: true } : {}) });
      updated = data;
      if (resultRaw) { await api.post("/assessment/save", JSON.parse(resultRaw)).catch(() => {}); }
    }
    sessionStorage.removeItem("sh_prefs");
    sessionStorage.removeItem("sh_last_result");
    return updated;
  } catch (e) {
    sessionStorage.removeItem("sh_prefs");
    return user;
  }
}
